/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { createOrUpdateTagModelSchema } from "../createOrUpdateTagModelSchema.ts";
import { int64CreatedOrUpdatedEntityModelSchema } from "../int64CreatedOrUpdatedEntityModelSchema.ts";
import { z } from "zod";

export const putApiTagsIdPathParamsSchema = z.object({
    "Id": z.coerce.number().int().describe("Идентификатор жанра")
    })

/**
 * @description Идентификатор обновляемого жанра
 */
export const putApiTagsId200Schema = z.lazy(() => int64CreatedOrUpdatedEntityModelSchema)

/**
 * @description Ошибка валидации | Жанр с указанным именем уже существует
 */
export const putApiTagsId400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const putApiTagsId401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const putApiTagsId403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Жанр не найден
 */
export const putApiTagsId404Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const putApiTagsId500Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Тело запроса
 */
export const putApiTagsIdMutationRequestSchema = z.lazy(() => createOrUpdateTagModelSchema).describe("Тело запроса")

export const putApiTagsIdMutationResponseSchema = z.lazy(() => putApiTagsId200Schema)